export default {
  saveYunLuCrowd: {
    url: '/api/yunlu/crowd/manage/createcrowd', // 保存/更新人群
    method: 'POST',
  },
  yunLuCrowdEstimate: { // 云鹿人群预计算
    url: '/api/yunlu/crowd/manage/numcalculation',
    method: 'POST',
  },
  getYunLuTag: { //标签筛选-查询云鹿标签信息列表
    url: '/api/yunlu/crowd/manage/labellist',
    method: 'GET',
    hasPathParams: true,
  },
  toDyCrowd: { // 云鹿人群转抖音人群
    url: '/api/yunlu/crowd/manage/toDyCrowd',
    method: 'POST',
  },
  crowdExcelUpload: { // 上传人群包excel
    url: '/api/yunlu/crowd/manage/crowdExcelUpload',
    method: 'POST',
  },
  saveCrowd: { // 保存人群包
    url: '/api/yunlu/crowd/manage/saveCrowd',
    method: 'POST',
  },
  getCrowdTime: { // 获取人群包创建次数
    url: '/api/yunlu/crowd/manage/getCrowdTime',
    method: 'GET',
  },
}
